module.exports = __webpack_public_path__ + "static/media/admin-logout.46707785.svg";